import React from 'react';

import { SVGComponentProps } from './svg.types';

const LinkTwoSVG = ({ size = '1em', ...otherProps }: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <g clipPath="url(#clip0_4920:87544)">
        <path
          d="M12.0229 15.3679L11.1029 16.2879C10.6462 16.6997 10.049 16.9204 9.4343 16.9047C8.81964 16.8889 8.23446 16.6378 7.79949 16.2033C7.36452 15.7687 7.11294 15.1837 7.09664 14.5691C7.08034 13.9544 7.30057 13.357 7.7119 12.8999L8.6319 11.9799C8.82073 11.7914 8.92692 11.5355 8.92711 11.2686C8.9273 11.0018 8.82147 10.7458 8.6329 10.5569C8.44433 10.3681 8.18847 10.2619 7.9216 10.2617C7.65474 10.2615 7.39873 10.3674 7.2099 10.5559L6.2909 11.4759C5.46435 12.3025 5 13.4235 5 14.5924C5 15.7613 5.46435 16.8824 6.2909 17.7089C7.11744 18.5355 8.23848 18.9998 9.4074 18.9998C10.5763 18.9998 11.6973 18.5355 12.5239 17.7089L13.4439 16.7899C13.6325 16.6015 13.7385 16.3459 13.7385 16.0793C13.7386 15.8127 13.6328 15.557 13.4444 15.3684C13.256 15.1799 13.0003 15.0739 12.7337 15.0738C12.4672 15.0737 12.2115 15.1795 12.0229 15.3679Z"
          fill="#BCBEC2"
        />
        <path
          d="M12.7115 9.86852L9.86852 12.7115C9.68008 12.9 9.57422 13.1555 9.57422 13.422C9.57422 13.6885 9.68008 13.9441 9.86852 14.1325C10.057 14.321 10.3125 14.4268 10.579 14.4268C10.8455 14.4268 11.1011 14.321 11.2895 14.1325L14.1325 11.2895C14.321 11.1011 14.4268 10.8455 14.4268 10.579C14.4268 10.3125 14.321 10.057 14.1325 9.86852C13.9441 9.68008 13.6885 9.57422 13.422 9.57422C13.1555 9.57422 12.9 9.68008 12.7115 9.86852Z"
          fill="#BCBEC2"
        />
        <path
          d="M17.7094 6.29106C17.3001 5.88175 16.8143 5.55706 16.2795 5.33554C15.7448 5.11402 15.1717 5 14.5929 5C14.0141 5 13.4409 5.11402 12.9062 5.33554C12.3715 5.55706 11.8856 5.88175 11.4764 6.29106L10.5564 7.21006C10.3678 7.3985 10.2618 7.65412 10.2617 7.92071C10.2616 8.18729 10.3674 8.44299 10.5559 8.63156C10.7443 8.82013 10.9999 8.92612 11.2665 8.92621C11.5331 8.92631 11.7888 8.8205 11.9774 8.63206L12.8974 7.71206C13.354 7.30033 13.9513 7.07957 14.566 7.09533C15.1806 7.11108 15.7658 7.36215 16.2008 7.79673C16.6357 8.23132 16.8873 8.81627 16.9036 9.43092C16.9199 10.0456 16.6997 10.643 16.2884 11.1001L15.3684 12.0201C15.1795 12.2086 15.0733 12.4645 15.0732 12.7314C15.073 12.9982 15.1788 13.2542 15.3674 13.4431C15.5559 13.6319 15.8118 13.7381 16.0787 13.7383C16.3455 13.7385 16.6015 13.6326 16.7904 13.4441L17.7094 12.5241C18.1187 12.1148 18.4434 11.629 18.6649 11.0942C18.8864 10.5595 19.0004 9.98636 19.0004 9.40756C19.0004 8.82876 18.8864 8.25563 18.6649 7.72089C18.4434 7.18616 18.1187 6.7003 17.7094 6.29106Z"
          fill="#BCBEC2"
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      <defs>
        <clipPath id="clip0_4920:87544">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkTwoSVG;
